import { Popup, ErrorPopup, httpAxios } from "../../core/classes/BaseStore";
import Vue from "vue";
import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { UserActivity } from "@/modules/users/viewmodels/UserActivity";

export const state = {
  userActivities: [],
};

export const getters = Object.assign(
  {
    userActivities: (state) => {
      return state.userActivities;
    },
    userActivityForActivity: (state) => (ActivityId) => {
      return state.userActivities.find((e) => e.activity_id === ActivityId);
    },
    isUserActivity: (state) => (ActivityId) => {
      return state.userActivities
        .map((e) => e.activity_id)
        .includes(ActivityId);
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/user-activities",
    UserActivity,
    {
      AfterCreate: (name, data) => {
        state.userActivities.push(data);
        return data;
      },
      AfterDestroy: (name, data) => {
        let element = state.userActivities.find((e) => e.id === data);

        state.userActivities.splice(
          state.userActivities.findIndex((e) => e.id === data),
          1
        );

        return data;
      },
    },
    {
      /**
       * Returns all my friends
       * this.$store.getters['userfriend/api'].Custom.My()
       */
      My: async () => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call("get", process.env.VUE_APP_BASE_URL + "/api/user-activities/my")
          .catch((err) => {
            throw Error(err);
          });

        let data = ApiResult.map((Entry) => {
          return new UserActivity(Entry);
        });

        Vue.set(state, "userActivities", data);

        return data;
      },
    }
  )
);

// mutations
export const mutations = {};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/user-activities",
  [],
  {}
);
